module.exports = __webpack_public_path__ + "img/04-trpg-material2021.0e302824.png";